import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BreadcrumbStatus } from './type';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  private $breadcrumbSubject = new Subject<BreadcrumbStatus | null>();
  private $breadcrumbChangedSubject = new Subject<any>();
  private $setBookingNumberSubject = new Subject<string>();

  constructor() { }

  breadcrumb(): Observable<BreadcrumbStatus | null>{
    return this.$breadcrumbSubject.asObservable();
  }

  setBreadcrumb(status: BreadcrumbStatus | null){
    this.$breadcrumbSubject.next(status);
  }

  onBreadcrumChanged(): Observable<any>{
    return this.$breadcrumbChangedSubject.asObservable();
  }

  updateBreadcrumb(){
    this.$breadcrumbChangedSubject.next(null);
  }

  setCurrentBookingNumber(bookingNumber: string){
    this.$setBookingNumberSubject.next(bookingNumber);
  }

  onBookingNumberChange(){
    return this.$setBookingNumberSubject.asObservable();
  }
}
